<template>
  <div class="m-3">
    <div class="flex gap-5">
      <feather-icon
        icon="AlignJustifyIcon"
        svgClasses="h-4 w-4"
        class="colorBlue"
      />
      <p class="font-bold">{{ title }}</p>
    </div>
    <div>
      <!-- Tabela em Desktop -->
      <table v-if="historicoOficinas.length > 0" class="showDesktop">
        <thead>
          <th class="w-1/6 text-center">Nome Fantasia:</th>
          <th class="w-1/6 text-center">Razão Social:</th>
          <th class="w-1/6 text-center" v-if="!modePatrimonio">
            Data de Entrada:
          </th>
          <th class="w-1/6 text-center" v-if="!modePatrimonio">
            Data de Previsão de Saída:
          </th>
          <th class="w-1/6 text-center" v-if="!modePatrimonio">
            Data de Saída Oficial:
          </th>
        </thead>
        <tbody>
          <tr
            v-for="item in historicoOficinas"
            :key="item.idHistoricoOficina"
            class="text-center"
          >
            <td>
              {{ item.nomeFantasia ? item.nomeFantasia : '--' }}
            </td>
            <td>
              {{ item.razaoSocial ? item.razaoSocial : '--' }}
            </td>
            <td v-if="!modePatrimonio">
              {{ item.dataEntrada ? item.dataEntrada : '--' }}
            </td>
            <td v-if="!modePatrimonio">
              {{ item.dataPrevisaoSaida ? item.dataPrevisaoSaida : '--' }}
            </td>
            <td v-if="!modePatrimonio">
              {{ item.dataSaidaOficial ? item.dataSaidaOficial : '--' }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Collapse em mobile -->
      <vs-collapse v-if="historicoOficinas.length > 0" class="showMobile">
        <vs-collapse-item
          v-for="item in historicoOficinas"
          :key="item.idHistoricoObservacao"
        >
          <div slot="header">
            <p><b>Nome Fantasia:</b></p>
            {{ item.nomeFantasia }}
          </div>
          <div v-if="!modePatrimonio">
            <p><b>Data de entrada:</b></p>
            {{ item.dataEntrada }}
            <p><b>Razão Social:</b></p>
            {{ item.razaoSocial }}
            <p>
              <b>Data de previsão de saída:</b>
            </p>
            {{ item.dataPrevisaoSaida }}
            <p><b>Data de saída oficial:</b></p>
            {{ item.dataSaidaOficial }}
          </div>
        </vs-collapse-item>
      </vs-collapse>

      <!-- Mensagem quando não há histórico -->
      <div v-else>
        <p class="p-5">Não há registros anteriores.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    historicoOficinas: Array,
    title: {
      type: String,
      default: 'Histórico de Oficinas Anteriores',
    },
    modePatrimonio: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
table {
  border-spacing: 1rem;
}

th {
  padding: 0;
}

.colorBlue {
  color: #00bfed;
}

.showDesktop {
  display: block;
}

.showMobile {
  display: none;
}

@media (max-width: 500px) {
  .showDesktop {
    display: none;
  }

  .showMobile {
    display: block;
  }
}
</style>
